require('/ui/components/table/head/tablehead.module.scss.module.css');

export const cell = "_cell_thpzl_1";
export const row = "_row_thpzl_1";
export const cellContents = "_cell-contents_thpzl_1";
export const selectCell = "_select-cell_thpzl_1";
export const sortButton = "_sort-button_thpzl_1";
export const sortIcon = "_sort-icon_thpzl_1";
